import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from 'src/app/core/core.module';
import { SalesOrderIntegrationView } from '../sales-order-overview.models';

@Component({
  selector: 'app-sales-order-integration-tab',
  standalone: true,
  imports: [CommonModule, CoreModule, TranslateModule],
  templateUrl: './sales-order-integration-tab.component.html',
  styleUrl: './sales-order-integration-tab.component.scss',
})
export class SalesOrderIntegrationTabComponent {
  @Input({ required: true }) public integrationView: SalesOrderIntegrationView | null = null;
}
